import extendedObservable from './base'
import RiotControl from 'riotcontrol'
import api from '../api'
import USPSUtils from '../utils/usps-utils'
import { isFunction } from 'lodash-es'
import '../observables/countries-observable'


// //////////////////////////////
// Application API Observable //
// //////////////////////////////

export const scrubAddress = (address) => {
  const payload = USPSUtils.mapUSPSAddressPayload(address, this.countriesModel)

  return api.usps.post(payload)
    .then((response) => {
      if (!response.scrubbedAddress) throw new Error('Empty response from Address validation Service')
      const unmapped = USPSUtils.unmapUSPSAddressPayload(response.scrubbedAddress)
      return unmapped
    })
}

export function ApplicationApi() {
  extendedObservable(this, 'applicationApi')

  // Show the USPS modal if the user needs to
  // review their scrubbed address
  const showModalIfNeeded = xhr => new Promise((resolve, reject) => {
    // if user review is needed, launch the modal
    if (xhr.userReviewNeeded) {
      RiotControl.trigger('modalFactory.create', {
        // resolveCallback: setAddress,
        title: 'Verify your address',
        template: 'usps-validation-modal',
        data: { xhr },
        buttons: [{
          title: 'Use this address',
          el_classes: 'btn btn-primary',
          on_click: address => resolve(USPSUtils.unmapUSPSAddressPayload(address)),
        }],
        links: [{
          title: 'Edit address',
          el_classes: 'btn btn-link btn-fixed btn-inline btn-link-underline',
          on_click: address => reject(USPSUtils.unmapUSPSAddressPayload(address)),
        }],
      })
    } else {
      const scrubbed = xhr.silentUpdate ? xhr.scrubbedAddress : xhr.userEnteredAddress
      // We need to manually set this
      scrubbed.scrubStatus = USPSUtils.SCRUBBED_VALUES.scrubbed
      // Perform a silent update to the address
      resolve(USPSUtils.unmapUSPSAddressPayload(scrubbed))
    }
  })

  // Event handlers
  this.on('scrubAddressWithModal', (address, cb, errCb) => {
    const payload = USPSUtils.mapUSPSAddressPayload(address, this.countriesModel)

    api.usps.post(payload)
      .then(xhr => showModalIfNeeded(xhr))
      .then((response) => {
        if (!response) throw new Error('Empty response from Address validation Service')
        cb(response)
      })
      .catch((err) => {
        if (isFunction(errCb)) errCb(err)
      })
  })

  this.on('scrubAddress', scrubAddress)
}
